export enum QueryKeys {
  Organization = "organization",
  MyProducts = "myProducts",
  ActivatedSubscriptions = "activatedSubscriptions",
  Macros = "macros",
  KnowledgeBaseIntroFlags = "knowledgeBaseIntroFlags",
}
